




































































































import restService from '@/services/restService';
import { Vue, Prop, Component } from 'vue-property-decorator';
import TransportationPermission from '../Passenger/models/TransportationPermission';
import PassengerTransportationPermissionTable from '@/components/Organization/PassengerTransportationPermissionTable.vue';
import Passenger from '../Passenger/models/Passenger';
import Destination from '../Passenger/models/Destination';
import { remove } from 'jszip';
import moment from 'moment';
import DateTimePicker from '../DatetimePicker.vue';

export interface IPermissionWithPassengerName {
  name: string;
  passengerInactive: boolean;
  mainPlace: Destination | null;
  transportationPermission: TransportationPermission;
  isValid: boolean;
}

@Component({
  components : {
    PassengerTransportationPermissionTable,
    DateTimePicker,
  }
})
export default class OrganizationTransportationPermissions extends Vue {
    today: Date = new Date();
    tab: number = 0;
    transportationPermissions: IPermissionWithPassengerName[] = [];
    showOnlyActivePermissions: boolean = false;
    useDateFilter: boolean = false;
    start = new Date();
    end = new Date();

    async mounted() {
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        this.today = today;
        this.start = new Date(new Date().getFullYear(), 0, 1);
        this.end = new Date(new Date().getFullYear() + 1, 0, 1);
        this.end.setDate(this.end.getDate() - 1);
        await this.getPermissions()    
    }

    get startDate() {
      return moment(this.start).format("YYYY-MM-DD");
    }

    setStartDate(val: string) {
      this.start = new Date(val);
    }

    get endDate() {
      return moment(this.end).format("YYYY-MM-DD");
    }

    setEndDate(val) {
      this.end = new Date(val);
    }

    dateFilterChanged(val) {
      this.useDateFilter = val;
    }

    get routeOrganizationId() {
        return this.$route.params.organizationId;
    }

    get all() {
      if (this.transportationPermissions) {
        let content = this.transportationPermissions;
        if (this.showOnlyActivePermissions) {
          content = content.filter(c => c.isValid);
        }
        return this.filterPermissionByTimePeriod(content);
      }
      return [];
    }

    get drafts() {
      if (this.transportationPermissions) {
        const content = this.transportationPermissions.filter(t => t.transportationPermission.isDraft);
        return this.filterPermissionByTimePeriod(content);
      }
      return [];
    }

    get completedPermissions() {
      if (this.transportationPermissions) {
        let content = this.transportationPermissions.filter(t => !t.transportationPermission.isDraft);
        if (this.showOnlyActivePermissions) {
          content = content.filter(c => c.isValid);
        }
        return this.filterPermissionByTimePeriod(content)
      }
      return [];
    }

    get expiredPermissions() {
      if (this.transportationPermissions) {
        // tslint:disable-next-line:max-line-length
        const content = this.transportationPermissions.filter(t => !t.isValid && !t.transportationPermission.isDraft);
        return this.filterPermissionByTimePeriod(content)
      }
    }

    async getPermissions() {
        const result = await restService.organizations.getTransportationPermissions(this.routeOrganizationId);
        const passengerIds = result.map(perm => perm.passengerId);
        const passengers = await restService.passengers.getPassengersByIds(passengerIds);
        this.transportationPermissions = result.map(r => {
          const passenger: Passenger = passengers.find(p => p.id === r.passengerId)
          if (!passenger){
            return null;
          }
          const passengerMainPlace = (this.$store.state.destination.destinations as Destination[])
              .find(d => passenger.destinationIds.includes(d.id));
          let endDate = null;
          if (r.endDate) {
              endDate = new Date(r.endDate);
          }

          const tableContent: IPermissionWithPassengerName = {
            name: passenger.name,
            passengerInactive: passenger.inactive,
            mainPlace: !!passengerMainPlace ? passengerMainPlace : null,
            transportationPermission: new TransportationPermission(r),
            isValid: endDate.getTime() >= this.today.getTime() || !endDate,
          }

          return tableContent;
        })
        .filter(tp => tp)
  }

  filterPermissionByTimePeriod(content: IPermissionWithPassengerName[]) {
    if (this.useDateFilter) {
      return content.filter(c => {
        const permissionEndDate = new Date(c.transportationPermission.endDateYMD);
        return permissionEndDate.getTime() >= this.start.getTime() && permissionEndDate.getTime() <= this.end.getTime();
      });
    }
    return content;
  }

  updatePermissions(permission: TransportationPermission) {
    const target = this.transportationPermissions.find(p => p.transportationPermission.id === permission.id);
    if (target) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      let permissionEndDate = null;
      if (permission.endDate) {
        permissionEndDate = new Date(permission.endDate);
      }
      const updatedPermission: IPermissionWithPassengerName = {
        name: target.name,
        passengerInactive: target.passengerInactive,
        mainPlace: target.mainPlace,
        transportationPermission: permission,
        isValid: permissionEndDate.getTime() >= today.getTime() || !permissionEndDate  
      };
      const index = this.transportationPermissions.indexOf(target);
      this.transportationPermissions.splice(index, 1, updatedPermission);
    }

  }
  
  removePermission(permission: TransportationPermission) {
    const target = this.transportationPermissions.find(p => p.transportationPermission.id === permission.id);
    if (target) {
      const index = this.transportationPermissions.indexOf(target);
      this.transportationPermissions.splice(index, 1);
    }
  }

}
